module.exports = __webpack_public_path__ + "static/img/silhouette_06.608356b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/silhouettes/thumbnail/silhouette_06.png
// module id = VP8T
// module chunks = 0